/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { QuestDisplay } from './QuestDisplay';
import {
    QuestDisplayFromJSON,
    QuestDisplayFromJSONTyped,
    QuestDisplayToJSON,
    QuestDisplayToJSONTyped,
} from './QuestDisplay';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { QuestConfigMilestoneResponse } from './QuestConfigMilestoneResponse';
import {
    QuestConfigMilestoneResponseFromJSON,
    QuestConfigMilestoneResponseFromJSONTyped,
    QuestConfigMilestoneResponseToJSON,
    QuestConfigMilestoneResponseToJSONTyped,
} from './QuestConfigMilestoneResponse';
import type { PrerequisiteResponse } from './PrerequisiteResponse';
import {
    PrerequisiteResponseFromJSON,
    PrerequisiteResponseFromJSONTyped,
    PrerequisiteResponseToJSON,
    PrerequisiteResponseToJSONTyped,
} from './PrerequisiteResponse';

/**
 * 
 * @export
 * @interface QuestConfigResponse
 */
export interface QuestConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof QuestConfigResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigResponse
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    id: string;
    /**
     * 
     * @type {Array<QuestDisplay>}
     * @memberof QuestConfigResponse
     */
    displayedOn?: Array<QuestDisplay>;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigResponse
     */
    shouldDisplayUnqualified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigResponse
     */
    requireProgressionOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    name: string;
    /**
     * Kicker rendered above the segment name on the journey map masthead (e.g. "Get in the Game" over Boot Camp).
     * @type {string}
     * @memberof QuestConfigResponse
     */
    groupLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigResponse
     */
    showQuestCompleteNotification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    questCompleteNotificationMessage?: string;
    /**
     * 
     * @type {QuestReset}
     * @memberof QuestConfigResponse
     */
    questReset: QuestReset;
    /**
     * 
     * @type {Array<QuestConfigMilestoneResponse>}
     * @memberof QuestConfigResponse
     */
    milestones: Array<QuestConfigMilestoneResponse>;
    /**
     * 
     * @type {Array<PrerequisiteResponse>}
     * @memberof QuestConfigResponse
     */
    prerequisites: Array<PrerequisiteResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigResponse
     */
    rewardConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof QuestConfigResponse
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * Quest-level catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof QuestConfigResponse
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * Per-reward auto-claim settings for quest-level rewards. Key is rewardConfigId, value is true for auto-reward, false for manual claim.
     * @type {{ [key: string]: boolean; }}
     * @memberof QuestConfigResponse
     */
    rewardAutoSettings?: { [key: string]: boolean; };
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfigResponse
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    rewardImage?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    backgroundImage?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigResponse
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigResponse
     */
    endAt?: number;
    /**
     * Per-user relative completion window in days (unset = open-ended).
     * @type {number}
     * @memberof QuestConfigResponse
     */
    completionWindowDays?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigResponse
     */
    maxUserCompletions?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfigResponse
     */
    currentUserCompletions?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigResponse
     */
    linkedQuestConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfigResponse
     */
    partnerServiceIds?: Array<string>;
    /**
     * Cheat-filtering match-bracketing gate — when true, this quest only progresses while the user has an active Match Start or Round Start in Redis
     * @type {boolean}
     * @memberof QuestConfigResponse
     */
    requireActiveMatch?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    revealText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    ctaButtonText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    brandLinkText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    questHeader?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    ctaStripColor?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    playableAdLayout?: QuestConfigResponsePlayableAdLayoutEnum;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    headlineFont?: QuestConfigResponseHeadlineFontEnum;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    completeHeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    completeSubtext?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    completeButtonText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    claimedHeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    claimedSubtext?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    claimedSponsorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    claimedCtaText?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfigResponse
     */
    claimedCtaUrl?: string;
}


/**
 * @export
 */
export const QuestConfigResponsePlayableAdLayoutEnum = {
    STACKED: 'STACKED',
    SPLIT: 'SPLIT'
} as const;
export type QuestConfigResponsePlayableAdLayoutEnum = typeof QuestConfigResponsePlayableAdLayoutEnum[keyof typeof QuestConfigResponsePlayableAdLayoutEnum];

/**
 * @export
 */
export const QuestConfigResponseHeadlineFontEnum = {
    ARCHIVO_BLACK: 'ARCHIVO_BLACK',
    MONTSERRAT: 'MONTSERRAT',
    NUNITO_SANS: 'NUNITO_SANS',
    TEKO: 'TEKO'
} as const;
export type QuestConfigResponseHeadlineFontEnum = typeof QuestConfigResponseHeadlineFontEnum[keyof typeof QuestConfigResponseHeadlineFontEnum];


/**
 * Check if a given object implements the QuestConfigResponse interface.
 */
export function instanceOfQuestConfigResponse(value: object): value is QuestConfigResponse {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('questReset' in value) || value['questReset'] === undefined) return false;
    if (!('milestones' in value) || value['milestones'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    return true;
}

export function QuestConfigResponseFromJSON(json: any): QuestConfigResponse {
    return QuestConfigResponseFromJSONTyped(json, false);
}

export function QuestConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'id': json['id'],
        'displayedOn': json['displayedOn'] == null ? undefined : ((json['displayedOn'] as Array<any>).map(QuestDisplayFromJSON)),
        'shouldDisplayUnqualified': json['shouldDisplayUnqualified'] == null ? undefined : json['shouldDisplayUnqualified'],
        'requireProgressionOrder': json['requireProgressionOrder'] == null ? undefined : json['requireProgressionOrder'],
        'name': json['name'],
        'groupLabel': json['groupLabel'] == null ? undefined : json['groupLabel'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': json['showQuestCompleteNotification'] == null ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': json['questCompleteNotificationMessage'] == null ? undefined : json['questCompleteNotificationMessage'],
        'questReset': QuestResetFromJSON(json['questReset']),
        'milestones': ((json['milestones'] as Array<any>).map(QuestConfigMilestoneResponseFromJSON)),
        'prerequisites': ((json['prerequisites'] as Array<any>).map(PrerequisiteResponseFromJSON)),
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : json['rewardAutoSettings'],
        'isSponsored': json['isSponsored'] == null ? undefined : json['isSponsored'],
        'sponsorName': json['sponsorName'] == null ? undefined : json['sponsorName'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'color': json['color'] == null ? undefined : json['color'],
        'externalUrl': json['externalUrl'] == null ? undefined : json['externalUrl'],
        'rewardImage': json['rewardImage'] == null ? undefined : json['rewardImage'],
        'backgroundImage': json['backgroundImage'] == null ? undefined : json['backgroundImage'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'completionWindowDays': json['completionWindowDays'] == null ? undefined : json['completionWindowDays'],
        'maxUserCompletions': json['maxUserCompletions'] == null ? undefined : json['maxUserCompletions'],
        'currentUserCompletions': json['currentUserCompletions'] == null ? undefined : json['currentUserCompletions'],
        'linkedQuestConfigIds': json['linkedQuestConfigIds'] == null ? undefined : json['linkedQuestConfigIds'],
        'partnerServiceIds': json['partnerServiceIds'] == null ? undefined : json['partnerServiceIds'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'revealText': json['revealText'] == null ? undefined : json['revealText'],
        'ctaButtonText': json['ctaButtonText'] == null ? undefined : json['ctaButtonText'],
        'brandLinkText': json['brandLinkText'] == null ? undefined : json['brandLinkText'],
        'questHeader': json['questHeader'] == null ? undefined : json['questHeader'],
        'ctaStripColor': json['ctaStripColor'] == null ? undefined : json['ctaStripColor'],
        'playableAdLayout': json['playableAdLayout'] == null ? undefined : json['playableAdLayout'],
        'headlineFont': json['headlineFont'] == null ? undefined : json['headlineFont'],
        'completeHeadline': json['completeHeadline'] == null ? undefined : json['completeHeadline'],
        'completeSubtext': json['completeSubtext'] == null ? undefined : json['completeSubtext'],
        'completeButtonText': json['completeButtonText'] == null ? undefined : json['completeButtonText'],
        'claimedHeadline': json['claimedHeadline'] == null ? undefined : json['claimedHeadline'],
        'claimedSubtext': json['claimedSubtext'] == null ? undefined : json['claimedSubtext'],
        'claimedSponsorMessage': json['claimedSponsorMessage'] == null ? undefined : json['claimedSponsorMessage'],
        'claimedCtaText': json['claimedCtaText'] == null ? undefined : json['claimedCtaText'],
        'claimedCtaUrl': json['claimedCtaUrl'] == null ? undefined : json['claimedCtaUrl'],
    };
}

export function QuestConfigResponseToJSON(json: any): QuestConfigResponse {
    return QuestConfigResponseToJSONTyped(json, false);
}

export function QuestConfigResponseToJSONTyped(value?: QuestConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'id': value['id'],
        'displayedOn': value['displayedOn'] == null ? undefined : ((value['displayedOn'] as Array<any>).map(QuestDisplayToJSON)),
        'shouldDisplayUnqualified': value['shouldDisplayUnqualified'],
        'requireProgressionOrder': value['requireProgressionOrder'],
        'name': value['name'],
        'groupLabel': value['groupLabel'],
        'description': value['description'],
        'isActive': value['isActive'],
        'showQuestCompleteNotification': value['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': value['questCompleteNotificationMessage'],
        'questReset': QuestResetToJSON(value['questReset']),
        'milestones': ((value['milestones'] as Array<any>).map(QuestConfigMilestoneResponseToJSON)),
        'prerequisites': ((value['prerequisites'] as Array<any>).map(PrerequisiteResponseToJSON)),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'rewardAutoSettings': value['rewardAutoSettings'],
        'isSponsored': value['isSponsored'],
        'sponsorName': value['sponsorName'],
        'logo': value['logo'],
        'color': value['color'],
        'externalUrl': value['externalUrl'],
        'rewardImage': value['rewardImage'],
        'backgroundImage': value['backgroundImage'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'completionWindowDays': value['completionWindowDays'],
        'maxUserCompletions': value['maxUserCompletions'],
        'currentUserCompletions': value['currentUserCompletions'],
        'linkedQuestConfigIds': value['linkedQuestConfigIds'],
        'partnerServiceIds': value['partnerServiceIds'],
        'requireActiveMatch': value['requireActiveMatch'],
        'revealText': value['revealText'],
        'ctaButtonText': value['ctaButtonText'],
        'brandLinkText': value['brandLinkText'],
        'questHeader': value['questHeader'],
        'ctaStripColor': value['ctaStripColor'],
        'playableAdLayout': value['playableAdLayout'],
        'headlineFont': value['headlineFont'],
        'completeHeadline': value['completeHeadline'],
        'completeSubtext': value['completeSubtext'],
        'completeButtonText': value['completeButtonText'],
        'claimedHeadline': value['claimedHeadline'],
        'claimedSubtext': value['claimedSubtext'],
        'claimedSponsorMessage': value['claimedSponsorMessage'],
        'claimedCtaText': value['claimedCtaText'],
        'claimedCtaUrl': value['claimedCtaUrl'],
    };
}

